// The campaigns sidebar's Status filter for a Google campaign. Pure function, shared by the sidebar.
import { hasCampaignEnded } from '@/lib/campaign-ended';
import type { CampaignData } from '@/lib/types';

/**
 * Whether a Google campaign passes the sidebar's Status filter.
 *
 * Archived campaigns show only under "Archived", campaigns Google reports as finished only under "Ended", and
 * everything else by its state. ERROR and CREATING bundle under
 * "draft" so failed campaigns stay reachable without an "error" chip, since error isn't a lifecycle state to
 * filter on (#4422).
 */
export function matchesSidebarStatus(
  campaign: Pick<CampaignData, 'state' | 'is_deleted' | 'googleads_campaign'>,
  filterStatuses: Set<string>,
): boolean {
  if (campaign.is_deleted) return filterStatuses.has('archived');
  // A campaign whose schedule in Google Ads has run out shows under "Ended", not under the state beneath it (#6622).
  if (hasCampaignEnded(campaign)) return filterStatuses.has('ended');
  const rawState = campaign.state?.toLowerCase() || 'draft';
  const stateKey = rawState === 'creating' || rawState === 'error' ? 'draft' : rawState;
  return filterStatuses.has(stateKey);
}
